// Carrega o select2 sob demanda (chunk separado), uma unica vez. So o JS e deferido;
// o CSS fica no curriculo.scss. Retorna Promise cacheada.
let _select2;

// Locales do proprio select2 (npm). Sem registrar um, as mensagens internas dele
// ("You can only select N items", "No results found") saem sempre em ingles.
const _locales = {
    'pt-br': { nome: 'pt-BR', carregar: () => import(/* webpackChunkName: "select2-locale-ptbr" */ 'select2/dist/js/i18n/pt-BR') },
    'en-us': { nome: 'en', carregar: () => import(/* webpackChunkName: "select2-locale-en" */ 'select2/dist/js/i18n/en') },
    'es-cl': { nome: 'es', carregar: () => import(/* webpackChunkName: "select2-locale-es" */ 'select2/dist/js/i18n/es') }
};

function _localeAtual() {
    const cultura = (typeof CULTURE_EMPREGARE !== 'undefined' && CULTURE_EMPREGARE ? CULTURE_EMPREGARE : 'pt-br').toLowerCase();
    return _locales[cultura] || _locales['pt-br'];
}

export function carregarSelect2() {
    if (!_select2) {
        const locale = _localeAtual();
        // O locale se registra em jQuery.fn.select2.amd, entao so carrega DEPOIS do select2.
        // Aplica como default global p/ toda inicializacao herdar sem repetir `language`.
        _select2 = import(/* webpackChunkName: "select2" */ 'select2')
            .then(modulo => locale.carregar().then(() => {
                $.fn.select2.defaults.set('language', locale.nome);
                return modulo;
            }));
    }
    return _select2;
}
